/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeResponseBody
 */
export interface MeResponseBody {
    /**
     * 
     * @type {string}
     * @memberof MeResponseBody
     */
    email: string;
}

/**
 * Check if a given object implements the MeResponseBody interface.
 */
export function instanceOfMeResponseBody(value: object): value is MeResponseBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function MeResponseBodyFromJSON(json: any): MeResponseBody {
    return MeResponseBodyFromJSONTyped(json, false);
}

export function MeResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeResponseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function MeResponseBodyToJSON(json: any): MeResponseBody {
    return MeResponseBodyToJSONTyped(json, false);
}

export function MeResponseBodyToJSONTyped(value?: MeResponseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

